export const VALID_STATUS = 'VALID_STATUS';
export const INVALID_STATUS = 'INVALID_STATUS';
export const UNDEFINED_VERIFY_STATUS = '';
